import { createAction } from 'redux-actions';
import getHubUsersForms from 'ui-forms-editor-automation-lib/api/getHubUsersForms';
import getHubUsersLeadFlows from 'ui-forms-editor-automation-lib/api/getHubUsersLeadFlows';
import getHubUsersRequestState from 'ui-forms-editor-automation-lib/selectors/hubUsers/getHubUsersRequestState';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
export const REQUEST_HUB_USERS = '@@lib/REQUEST_HUB_USERS';
export const RECEIVE_HUB_USERS = '@@lib/RECEIVE_HUB_USERS';
export const FAIL_GETTING_HUB_USERS = '@@lib/FAIL_GETTING_HUB_USERS';
const requestHubUsers = createAction(REQUEST_HUB_USERS);
const receiveHubUsers = createAction(RECEIVE_HUB_USERS);
const failGettingHubUsers = createAction(FAIL_GETTING_HUB_USERS);
const fetchHubUsers = () => (dispatch, getState) => {
  const state = getState();
  const applicationName = getApplicationName(state);
  if (!getHubUsersRequestState(state).shouldBeRequested()) {
    return Promise.resolve();
  }
  dispatch(requestHubUsers());
  let apiFunctionToCall;
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      apiFunctionToCall = getHubUsersLeadFlows;
      break;
    case APPLICATION_NAMES.FORMSUI:
    default:
      apiFunctionToCall = getHubUsersForms;
      break;
  }
  return apiFunctionToCall().then(users => {
    dispatch(receiveHubUsers(users));
  }).catch(() => {
    dispatch(failGettingHubUsers());
  });
};
export default fetchHubUsers;